import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { BatchVisibilityView } from '../components/views/batchVisibilityView'
import { Page, PageHeader } from '../ui'

/**
 * Admin > Omnibus Batch Visibility: hide/show whole funding batches across
 * the omnibus system. The view handles the admin gate itself — the list
 * endpoint 403s non-admin/non-Sentinel users and bounces them home.
 */
function OmnibusBatchVisibility() {
    return (
        <div className="omnibusBatchVisibility">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Admin"
                        title="Omnibus Batch Visibility"
                        intro="Choose which funding batches are visible through the omnibus system. Hidden batches drop out of counts, claim lists and new schedules for every user until toggled back on."
                    />
                    <BatchVisibilityView />
                </Page>
            </MainView>
        </div>
    )
}

export default OmnibusBatchVisibility
